import { QueryClient } from '@tanstack/react-query';

// Central TanStack Query client. This is the React analog of Riverpod's
// provider cache: queries replace `FutureProvider`/`StreamProvider`, and
// `queryClient.invalidateQueries(...)` replaces `ref.invalidate(...)`.
//
// Defaults tuned to mirror the Flutter app's behaviour:
//   * staleTime 0 on most data — the dashboard wants fresh due-counts; the
//     specific queries that should cache longer set their own staleTime.
//   * one retry (the Dart repos mostly let a single failure surface to the
//     ErrorState widget; the profile sync's own 4-attempt loop is ported
//     separately in useUserProfile).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
